import { jsx as _jsx } from "react/jsx-runtime";
import useIconProps from '../utils/use-icon-props';
const TabArrow = (props) => {
    var _a;
    const { down } = props;
    const iconProps = useIconProps(props);
    return (_jsx("svg", Object.assign({}, iconProps, { style: Object.assign(Object.assign({}, iconProps.style), { flexShrink: 0, transform: down ? 'rotate(0deg)' : 'rotate(-180deg)', transition: 'transform 150ms ease' }), viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M28 10L16.0001 22L4 10", stroke: "currentColor", strokeWidth: (_a = props.strokeWidth) !== null && _a !== void 0 ? _a : 2.5, strokeLinecap: "round" }) })));
};
export default TabArrow;
